module.exports = __webpack_public_path__ + "static/media/gusec.3e11cccd.png";